import React from 'react';
import I18N from '@leverege/i18n';
import { Content, Flex, Text, Button, Dialog } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import { LoadingView } from '@leverege/molten/views';
import S from '../../PairForm.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.intermediate.types.LocatorLost');
export default class LocatorLost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sale: null
    };
  }
  componentDidMount() {
    const {
      location,
      selectedObject
    } = this.props;
    const {
      locator
    } = selectedObject;
    const loc = {
      ...location,
      ref: location.ref.substring(0, location.ref.lastIndexOf('/')),
      type: 'location'
    };
    const actions = DataSources.getActions(loc);
    if (actions) {
      GlobalState.dispatch(actions.child('sales').search({
        queryName: 'lostLocatorSale',
        filter: {
          type: 'logical',
          operator: 'and',
          conditions: [{
            type: 'equals',
            field: 'data/locator/id',
            value: locator.id
          }]
        },
        sort: [{
          field: 'created',
          order: 'desc',
          missing: '_last'
        }]
      })).then(res => {
        const {
          items
        } = res;
        if (items.length > 0) {
          this.setState({
            sale: items[0]
          });
        }
      });
    }
  }
  onChangeLocation = async evt => {
    const {
      onOkay,
      selectedObject
    } = this.props;
    const {
      sale
    } = this.state;
    const {
      locator
    } = selectedObject;
    const serialNumber = locator?.data?.serialNumber || '';
    const closeLoading = LoadingView.showDialog(t('loading', {
      serialNumber
    }));
    closeLoading();
    onOkay?.({
      data: 'locatorFound',
      value: {
        saleId: sale?.id
      }
    });
  };
  render() {
    const {
      areaClassName,
      footerClassName,
      onClose,
      titleVariant,
      titleIcon
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: t('title'),
          icon: titleIcon,
          children: /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            className: S.close,
            onClick: onClose
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        className: areaClassName,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colL",
          children: [/*#__PURE__*/_jsx("img", {
            className: S.locatorError,
            src: tIcon('icon'),
            alt: t('locatorWarning'),
            height: 92,
            width: 136
          }), /*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: t('formTitle')
          }), /*#__PURE__*/_jsx(Text, {
            children: t('message')
          })]
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        className: footerClassName,
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: this.onChangeLocation,
          children: t('okay')
        })]
      })]
    });
  }
}